<template>
    <div class="mit-menu">
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    {{userModel.fname}} {{userModel.lname}}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{userModel.email}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list nav dense>
                  <div v-if="userModel && userModel.role == userRoles.ADMIN">
                    <v-list-item to="/admin">
                      <v-list-item-icon>
                        <v-icon>mdi-shield-crown</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Admin</v-list-item-title>
                    </v-list-item>
                  </div>
                  <div v-if="userModel && userModel.role >= userRoles.MANAGER">
                    <v-subheader>Reports</v-subheader>
                    <v-list-item link to="/manage/reports/keys/lowinventory">
                      <v-list-item-icon><v-icon>mdi-chart-box</v-icon></v-list-item-icon>
                      <v-list-item-title>Low Inventory
                        <span v-if="keyStats.stats">
                          <span style="color:red;" v-if="keyStats.stats.available[0] > 0"><b>({{keyStats.stats.available[0]}})</b></span>
                          <span style="color:orange;" v-if="keyStats.stats.available[0] == 0 && keyStats.stats.available[1] > 0"><b>({{keyStats.stats.available[1]}})</b></span>
                        </span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-subheader>Manage</v-subheader>

                    <v-list-item link to="/manage/keys">
                      <v-list-item-icon><v-icon>mdi-key-chain</v-icon></v-list-item-icon>
                      <v-list-item-title>Manage Keys</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/manage/borrowed">
                      <v-list-item-icon><v-icon>mdi-account-multiple</v-icon></v-list-item-icon>
                      <v-list-item-title>Manage Borrowed</v-list-item-title>
                    </v-list-item>

                    <v-subheader>Actions</v-subheader>

                    <v-list-item link to="/borrow">
                      <v-list-item-icon>
                        <v-icon class="reverse-image">mdi-key-arrow-right</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Borrow Key</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/return">
                      <v-list-item-icon>
                        <v-icon>mdi-key-arrow-right</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Return Key</v-list-item-title>
                    </v-list-item>
                    <v-list-item link to="/lost">
                      <v-list-item-icon>
                        <v-icon>mdi-key-alert</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Lost Key</v-list-item-title>
                    </v-list-item>
                  </div>


                  <v-subheader>My Keys</v-subheader>

                  <v-list-item link to="/my/keys">
                    <v-list-item-icon>
                      <v-icon>mdi-account-key</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Keys</v-list-item-title>
                  </v-list-item>
            </v-list>
            <v-list dense>
              <v-divider></v-divider>
              <v-list-item v-if="userModel" @click="logout()">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Sign out</v-list-item-title>
              </v-list-item>
            </v-list>
      </div>
</template>

<script>
import MitConfigService from '../services/MitConfigService.js';
import MitKeysService from '../services/MitKeysService.js';

export default {
  name: 'MitMenu',
  components: {
  },
  props: {
    userModel: Object,
    userRoles: Object
  },
  data() {
    return {
      keyStats:{}
    }
  },
  mounted() {
    MitKeysService.requestGetKeysStats()
      .then((data) => {
        this.keyStats = data;
      })
      .catch((error) => {
        console.log('An error occurred trying to get keys stats', error);
      });
  },
  methods : {
        login(){
          console.log(this.userModel);
          this.$emit('login');
        },
        logout() {
          this.$emit('logout');
        }
  }
}
</script>

<style lang="scss" scoped>
  .reverse-image {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
</style>
